import type { ReactNode } from "react";
import { Bold, Subtitle } from "~/components/layout/text";
import { filled } from "~/util";

type JournalLineProps = {
    title?: string;
    data?: ReactNode;
    children?: ReactNode;
};

export const JournalLine = ({ title, data, children }: JournalLineProps) => {
    return (
        <Subtitle size="md">
            {filled(title) && <Bold>{title}:</Bold>} {(children ?? data) || "-"}
        </Subtitle>
    );
};
